import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {DaySelectBoxV2} from "../common/DaySelectBoxV2";
import {
  formatCost,
  getNextDay,
  getParameter,
  getToday,
  getValue,
  openPopup,
  pagingBtn2,
  setValue
} from "../../../static/js/Common2";
import {
  costFormat,
  deliveryFormat, formatSecurityTel,
  telFormat,
  payTypeFormat
} from "../../../static/js/service/formatService";
import prev from "../../../static/image/prev.png";
import next from "../../../static/image/next.png";
import {getOrderDetailApi} from "../../../static/js/service/orderService";
import OrderPopupV2 from "./OrderPopupV2";
import {subNavEvent} from "../../../static/js/service/commonService";
import excelIcon from "../../../static/image/v2/excel.png";
import {callLoadingEvent} from "utils/CommonUtils";
import * as XLSX from "xlsx";
import {useGetOrderCeoApi} from "../../../hooks/orderHook";
import {cancelTypeFormat, orderTypeFormat} from "utils/formatUtils";
import {getOrderCeoApi} from "../../../api/orderApi";
import {useShopAdminDetail2} from "../../../static/js/hock/shopHock";

export default function OrderListV2() {
  const [shopList, setShopList] = useState([]);
  const [shopId, setShopId] = useState();
  const [list, setList] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [approvalTpcd1, setApprovalTpcd1] = useState();
  const page = getParameter("page") === null ? 1 : Number(getParameter("page"));
  const status = Number(getParameter("status")) || 0;
  const startDate = getParameter("startDate") === null ? getToday() : getParameter("startDate");
  const endDate = getParameter("endDate") === null ? getNextDay() : getParameter("endDate");
  const dayType = getParameter("dayType") === null ? 1 : Number(getParameter("dayType"));
  const keywordType = getParameter("keywordType") === null ? "1" : getParameter("keywordType");
  const keyword = getParameter("keyword") === null ? "" : getParameter("keyword");
  const orderType = getParameter("orderType") === null ? 0 : Number(getParameter("orderType"));

  useEffect(() => {
    const handleClickOutside = (e) => {
      const select = document.querySelectorAll(".selectEvent");
      select.forEach((element) => {
        element.classList.remove("active");
      });

      if (e.target.classList.contains("selectText")) {
        const dataHref = e.target.getAttribute("data-href");
        const selectBox = document.getElementById(`${dataHref}`);
        selectBox.classList.add("active");
      }
    };

    document.addEventListener("click", handleClickOutside);
    subNavEvent("calculateNav", "calculate1");
  }, []);

  useEffect(() => {
    if(totalPage !== 0) {
      pagingBtn2(page, totalPage, 10, `/v2/orderList?${urlLink()}`);
    }
  }, [list]);

  let data;

  if (shopId) {
    data = {
      page: page,
      count: 10,
      shopId: shopId,
      startDate: startDate,
      endDate: endDate
    }

    if (status !== 0) {
      data.status = status;
    }

    if (keyword !== "") {
      data.keyword = keyword;
      data.searchType = keywordType
    }
  }

  useGetOrderCeoApi({setList, setTotalPage}, data);
  useShopAdminDetail2({setApprovalTpcd1}, shopId);

  const orderTypeText = orderTypeFormat(status);

  let keywordText;
  switch (keywordType) {
    case "1":
      keywordText = "주문번호";
      break;
    case "2":
      keywordText = "고객명";
      break;
    case "3":
      keywordText = "고객 연락처";
      break;
    default:
      keywordText = "주문번호";
      break;
  }

  const orderTypeSelectEvent = (id, name) => {
    const orderTypeBox = document.querySelector(".orderTypeText");
    orderTypeBox.setAttribute("data-id", id);
    orderTypeBox.innerText = name
  }
  const keywordSelectEvent = (id, name) => {
    const keywordBox = document.querySelector(".keywordText");
    keywordBox.setAttribute("data-id", id);
    keywordBox.innerText = name
  }

  const urlLink = () => {
    const startDate = getValue("startDate");
    const endDate = getValue("endDate");
    const dayType = document.querySelector(".daySelectText").getAttribute("data-type");
    const orderType = document.querySelector(".orderTypeText").getAttribute("data-id");
    const keywordType = document.querySelector(".keywordText").getAttribute("data-id");
    const keyword = getValue("searchText");

    return `shopSelect=${shopId}&startDate=${startDate}&endDate=${endDate}&dayType=${dayType}&status=${orderType}&keywordType=${keywordType}&keyword=${keyword}`
  }

  const searchEvnet = () => {
    const startDate = getValue("startDate");
    const endDate = getValue("endDate");
    const dayType = document.querySelector(".daySelectText").getAttribute("data-type");
    const status = document.querySelector(".orderTypeText").getAttribute("data-id");
    const keywordType = document.querySelector(".keywordText").getAttribute("data-id");
    const keyword = getValue("searchText");

    window.location.href = `/v2/orderList?shopSelect=${shopId}&startDate=${startDate}&endDate=${endDate}&dayType=${dayType}&status=${status}&keywordType=${keywordType}&keyword=${keyword}`
  }

  const orderDetailEvent = (id) => {
    getOrderDetailApi(id).then((response) => {
      let tel = response.securityTel === "" ? telFormat(response.customerTel) : formatSecurityTel(response.securityTel);

      setValue("orderId", id);

      setValue("tel", tel);
      setValue("shopMemo", response.shopMemo);

      if(response.deliveryType !== 2) {
        setValue("address", `${response.road} ${response.addressDetail}`);
        setValue("riderMemo", response.riderMemo);
      }

      const cancelTypeBox = document.getElementById("cancelTypeBox");
      if (response.cancelType) {
        cancelTypeBox.classList.remove("hide");
        setValue("cancelType", cancelTypeFormat(response.cancelType))
      } else {
        cancelTypeBox.classList.add("hide");
      }

      const orderTbody = document.getElementById("orderTbody");
      orderTbody.innerHTML = "";
      response.menuList.forEach((value) => {
        let optionCost = 0;
        for(let i = 0; value.optionList.length > i; i++) {
          optionCost += value.optionList[i].cost;
        }



        const tr = document.createElement("tr");

        tr.innerHTML =  `<td class="textLeft">${value.menuName}` +
                        `<ul class="optionList"><li>가격 - ${value.menuCostName} ${formatCost(value.cost)}원</li></ul></td>` +
                        `<td>${formatCost(value.cost + optionCost)}원</td>` +
                        `<td>${value.count}</td>` +
                        `<td>${formatCost((value.cost + optionCost) * value.count)}원</td>`;

        const optionList = tr.querySelector(".optionList");
        for(let i = 0; value.optionList.length > i; i++) {
          const li = document.createElement("li");
          li.innerHTML = `<li>옵션 - ${value.optionList[i].name} ${formatCost(value.optionList[i].cost)}원</li>`;
          optionList.appendChild(li);
        }

        orderTbody.appendChild(tr);
      });
      const tr1 = document.createElement("tr");
      tr1.innerHTML = `<td colSpan="3" class="textLeft">배송비/포장할인</td>` +
                      `<td>${formatCost(response.deliveryCost + response.extraCost - response.packagingDiscountCost)}원</td>`;
      orderTbody.appendChild(tr1);

      response.useCouponList.forEach((value) => {
        const tr = document.createElement("tr");
        tr.innerHTML = `<td colspan="3" class="textLeft">쿠폰명 : ${value.couponName}</td>` +
          `<td>-${formatCost(value.couponDiscountCost)}원</td>`;

        orderTbody.appendChild(tr);
      });

      const tr2 = document.createElement("tr");
      tr2.innerHTML = `<td colSpan="3" class="textLeft">총합계</td>` +
        `<td>${formatCost(response.paymentCost)}원</td>`;
      orderTbody.appendChild(tr2);


      openPopup("orderPopup");
    })
  }

  const orderListBox = list.map((value, index) => {
    return (
      <div className="tableBodyV2" key={index} onClick={() => orderDetailEvent(value.id)}>
        <div className="width140">{value.createDateTime}</div>
        <div className="width140">{value.id}</div>
        <div className="width140">
          {document.getElementById("shopSelectText").innerText}
        </div>
        <div className="width300">{value.menuName}</div>
        <div className="width100">{deliveryFormat(value.deliveryType)}</div>
        <div className="width110">{payTypeFormat(value.paymentType)}</div>
        <div className="width140">{costFormat(value.paymentCost)}원</div>
        <div className="width100">{orderTypeFormat(value.status)}</div>
      </div>
    )
  })

  const excelDownEvent = async () => {
    callLoadingEvent(1);
    let excelList = [];
    let currentPage = 1;
    let pageSize = 50;

    let excelSearchData = {
      page: currentPage,
      count: pageSize,
      shopId: shopId,
      startDate: startDate,
      endDate: endDate
    }

    if (status !== 0) {
      excelSearchData.status = status;
    }

    if (keyword !== "") {
      excelSearchData.keyword = keyword;
      excelSearchData.searchType = keywordType
    }

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    let hasNextPage = true;

    while (hasNextPage) {
      // 페이지 번호를 업데이트하여 API 호출
      excelSearchData.page = currentPage;

      // API 호출
      const getData = await getOrderCeoApi(excelSearchData);

      // 데이터를 excelList에 추가
      excelList = [...excelList, ...getData.data];

      // 다음 페이지가 있는지 확인
      if (getData.data.length < pageSize) {
        hasNextPage = false; // 데이터 개수가 페이지 크기보다 적으면 마지막 페이지
      } else {
        currentPage++; // 다음 페이지로 이동
      }

      // 1초 대기
      await delay(1000);
    }

    downloadExcel(excelList);
  }

  const downloadExcel = (data) => {
    const formatData = data.map(item => ({
      "주문일시": item.createDateTime,
      "주문번호": item.id,
      "상점명": document.getElementById("shopSelectText").innerText,
      "메뉴": item.menuName,
      "배달유형": deliveryFormat(item.deliveryType),
      "결제방법": payTypeFormat(item.paymentType),
      "총 결제금액": `${costFormat(item.paymentCost)}원`,
      "쿠폰금액": `${item.couponDiscntCost > 0 ? "-" : ""}${costFormat(item.couponDiscntCost)}원`,
      "주문상태": `${orderTypeFormat(item.status)}`
    }));

    // 엑셀 시트 생성
    const worksheet = XLSX.utils.json_to_sheet(formatData);
    const workbook = XLSX.utils.book_new();

    // 워크북에 시트 추가
    XLSX.utils.book_append_sheet(workbook, worksheet, 'OrderList');

    // 엑셀 파일 생성 및 다운로드
    XLSX.writeFile(workbook, 'orderList.xlsx');
    callLoadingEvent(2);
  }

  return (
    <>
      <section id="loadingPopup" className="popup d-none a-center j-center">
        <div className="loadingio-spinner-rolling-10rx3c6i88xj">
          <div className="ldio-5sgltw2ts33">
            <div></div>
          </div>
        </div>
      </section>
      <main id="ReviewListV2" className="mainV2">
        <TopBoxV2 shopList={shopList} />
        <OrderPopupV2 />

        <div className="container">
          <section className="containerInner">
            <PageNameV2 title1='정산 관리' title2='주문내역' />
            <div className="pageTitle mb-10 d-flex a-center j-between">
              <PageTitleV2 title="주문내역" countText="" count="" unit="" />
            </div>
            <div className="topMenu between">
              <div id="shopSelectBox">
                <ShopSelectBoxV2 url="/v2/orderList" setShopId={setShopId} setShopList={setShopList} />
              </div>
              {approvalTpcd1 === 4 &&
                <button className="commonBtn d-flex a-center j-center excelBtn" onClick={excelDownEvent}>
                  <img className="icon" src={excelIcon} alt="엑셀 다운받기"/>
                  엑셀 다운받기
                </button>
              }
            </div>
            <div className="bg-white pt-15 pr-20 pb-15 pl-20">
              <div className="d-flex a-center j-left mb-15">
                <div className="mr-30">
                  <p className="fw-7 mb-10">날짜</p>
                  <DaySelectBoxV2 startDate={startDate} endDate={endDate} dayType={dayType} />
                </div>
                <div>
                  <p className="fw-7 mb-10">주문 상태</p>
                  <div className='selectBox'>
                    <div id="orderTypeSelect" className='select selectEvent width160'>
                      <div className='orderTypeText selectText' data-id={orderType} data-href="orderTypeSelect">
                        {orderTypeText}
                      </div>
                      <ul className='orderType selectOptionList'>
                        <li className='selectoption' onClick={() => orderTypeSelectEvent("0", "전체")}>전체</li>
                        <li className='selectoption' onClick={() => orderTypeSelectEvent("1", "접수중")}>접수중</li>
                        <li className='selectoption' onClick={() => orderTypeSelectEvent("2", "조리중")}>조리중</li>
                        <li className='selectoption' onClick={() => orderTypeSelectEvent("3", "배달중")}>배달중</li>
                        <li className='selectoption' onClick={() => orderTypeSelectEvent("4", "배달완료")}>배달완료</li>
                        <li className='selectoption' onClick={() => orderTypeSelectEvent("5", "포장완료")}>포장완료</li>
                        <li className='selectoption' onClick={() => orderTypeSelectEvent("6", "픽업완료")}>픽업완료</li>
                        <li className='selectoption' onClick={() => orderTypeSelectEvent("7", "주문취소")}>주문취소</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <p className="fw-7 mb-10">검색어 직접입력</p>
                <div className="d-flex a-center j-left">
                  <div className='selectBox'>
                    <div id="keywordSelect" className='select selectEvent width160'>
                      <div className='keywordText selectText' data-id={keywordType} data-href="keywordSelect">
                        {keywordText}
                      </div>
                      <ul className='keyword selectOptionList'>
                        <li className='selectoption' onClick={() => keywordSelectEvent("1", "주문번호")}>주문번호</li>
                        <li className='selectoption' onClick={() => keywordSelectEvent("2", "고객명")}>고객명</li>
                        <li className='selectoption' onClick={() => keywordSelectEvent("3", "고객 연락처")}>고객 연락처</li>
                      </ul>
                    </div>
                  </div>
                  <input id="searchText" defaultValue={keyword} className="searchText ml-5 mr-10" type="text" />
                  <button type="button" id="searchBtn" className="commonBtn blueBtn width90" onClick={() => searchEvnet()}>검색</button>
                </div>
              </div>
            </div>
            <div className="tableBoxV2 marginTop20">
              <div className="tableHeadV2">
                <div className="width140">주문일시</div>
                <div className="width140">주문번호</div>
                <div className="width140">상점명</div>
                <div className="width300">메뉴</div>
                <div className="width100">배달유형</div>
                <div className="width110">결제방법</div>
                <div className="width140">총 결제금액</div>
                <div className="width100">주문상태</div>
              </div>
              {orderListBox}
            </div>

            <div id="pagingBox">
              <button className="pageBtn pageStartBtn">
                <img src={prev} alt="첫 페이지" />
              </button>
              <ul id="pagingList">

              </ul>
              <button className="pageBtn pageEndBtn">
                <img src={next} alt="마지막 페이지" />
              </button>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}